module.exports = __webpack_public_path__ + "img/202412_01.981f298a.jpg";